import ScalarIcon_default from "./ScalarIcon.vue.js";
import ScalarIconLegacyAdapter_default from "./ScalarIconLegacyAdapter.vue.js";
export { ScalarIcon_default as ScalarIcon, ScalarIconLegacyAdapter_default as ScalarIconLegacyAdapter };
